import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import usersAction from '@state/user/actions';
import userApi from '@api/userApi';
import devicesApi from '@api/devicesApi';

function useUsersEditCreate() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const [form] = Form.useForm();
  const dataInit = useSelector(({ user: a }) => a.newUser);
  const idToEdit = useSelector(({ user: a }) => a.userIdToEdit.id);
  const currentUserRol = useSelector(({ user }) => user.role);

  const [dataForm, setDataForm] = useState(dataInit);
  const [imageFile, setImageFile] = useState();

  const [isModalVisible, setIsModalVisible] = useState(false);
  // eslint-disable-next-line
  const [modalData, setModalData] = useState({});

  const [businessData, setBusinessData] = useState([]);
  const [devicesData, setDevicesData] = useState([]);
  const [clientsData, setClientsData] = useState([]);

  const [typeVisitor, setTypeVisitor] = useState('');

  const [loadingForm, setLoadingForm] = useState(false);

  const abortC = new AbortController();
  const { signal } = abortC;

  const skip = 0;
  const limit = 1000;
  const defaultData = {
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    birthdate: '',
    role: '',
    password: '',
    business_id: [],
    devices_id: [],
    clients_id: [],
  };

  // eslint-disable-next-line
  const createUser = () => { // create user  

    const body = {
      ...dataForm,
      birthdate: moment(dataForm.birthdate).format('YYYY-MM-DD'),
    };

    // Lógica para determinar los arreglos basados en el rol y el tipo de negocio
    if (dataForm.role === 'Superadmin') {

        body.business_id = [];
        body.devices_id = [];
        body.clients_id = [];

} else if (dataForm.role === 'Admin' || dataForm.role === 'Analyst') {

        body.devices_id = [];
        body.clients_id = [];
        if (body.business_id.length === 0) {

          message.error('linea de negocio requerida');
          return false;

}

} else if (dataForm.role === 'Visitor') {

          if (body.business_id_visitor !== '') {

            body.business_id = [body.business_id_visitor];

} else {

            message.error('linea de negocio requerida');
            return false;

}

        if (typeVisitor === 'Comunidades') {

          if (body.clients_id.length > 0) {

            body.devices_id = [];
            body.clients_id = [body.clients_id];

} else {

            message.error('Comunidad requerida');
            return false;

}

} else if (body.devices_id.length > 0) {

            body.clients_id = [];
            body.devices_id = [body.devices_id];

} else {

            message.error('dispositivo requerido');
            return false;

}

}

    setLoadingForm(true);
    userApi.createUser({ signal, body })
    .then(async (response) => {

      if (imageFile !== null && imageFile !== undefined) {

        const formData = new FormData();
        formData.append('image_file', imageFile);
        try {

          // eslint-disable-next-line
          const responseImg = await userApi.imageProfileData({ signal, id: response?.id, formData });
          // Process the response here
          console.log('Response:', responseImg);

} catch (error) {

          // Handle any errors
          console.error('Error:', error);

}

}

      setLoadingForm(false);

      message.success(t('forms.users.feedbacks.create_success'));
      setDataForm(defaultData);
      dispatch(usersAction.setCreateEditUser(defaultData));
      dispatch(usersAction.setIdUserEdit({ id: null, isAdmin: null }));
      history.push('/usuarios');

    })
    .catch((resError) => {

      message.error(resError.data?.detail || 'Error al crear usuario');
      setLoadingForm(false);

});

  };

  // eslint-disable-next-line
  const editUsers = () => {

    const body = {
      ...dataForm,
      birthdate: moment(dataForm.birthdate).format('YYYY-MM-DD'),
    };

    // Lógica para determinar los arreglos basados en el rol y el tipo de negocio
    if (dataForm.role === 'Superadmin') {

      body.business_id = [];
      body.devices_id = [];
      body.clients_id = [];

} else if (dataForm.role === 'Admin' || dataForm.role === 'Analyst') {

        body.devices_id = [];
        body.clients_id = [];
        if (body.business_id.length === 0) {

          message.error('linea de negocio requerida');
          return false;

}

} else if (dataForm.role === 'Visitor') {

          if (body.business_id_visitor !== '') {

            body.business_id = [body.business_id_visitor];

} else {

            message.error('linea de negocio requerida');
            return false;

}

        if (typeVisitor === 'Comunidades') {

          if (body.clients_id.length > 0) {

            body.devices_id = [];
            body.clients_id = [body.clients_id];

} else {

            message.error('Comunidad requerida');
            return false;

}

} else if (body.devices_id.length > 0) {

            body.clients_id = [];
            body.devices_id = [body.devices_id];

} else {

            message.error('dispositivo requerido');
            return false;

}

}

    setLoadingForm(true);
    userApi.updateUser({ id: idToEdit, body, signal })
      .then(async (response) => {

        if (imageFile !== null && imageFile !== undefined) {

          const formData = new FormData();
          formData.append('image_file', imageFile);
          try {

            // eslint-disable-next-line
            const response = await userApi.imageProfileData({ signal, id: idToEdit, formData });
            // Process the response here
            console.log('Response:', response);

} catch (error) {

            // Handle any errors
            console.error('Error:', error);

}

}

        setLoadingForm(false);
        // eslint-disable-next-line
        setDataForm(defaultData);
        dispatch(usersAction.setIdUserEdit({ id: null, isAdmin: null }));
        dispatch(usersAction.setCreateEditUser(defaultData));
        message.info('Usuario editado');
        history.push('/usuarios');

      })
      .catch((resError) => {

        setLoadingForm(false);
        // eslint-disable-next-line
        console.log(resError);
        message.error(resError.data?.detail || 'Error al editar usuario');

      });

  };

  const onFinish = useCallback((values) => { // submit: create user or edit user

    if (idToEdit) {

      editUsers();

} else {

      createUser();

}
    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo);
    message.error(t('tables.logs.rows.error'));

  };

  const formOnValuesChange = useCallback( // handle data of api
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);
      setDataForm({ ...dataForm, [key[0]]: data[0] });
      dispatch(usersAction.setCreateEditUser({ ...dataForm, [key[0]]: data[0] }));

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const cancelCreateEditUser = useCallback( // cancel: edit user, create user
    () => {

      history.push('/usuarios');

    },
    // eslint-disable-next-line
    [],

  );

  const fileRequest = useCallback(
    ({ file, onSuccess, onProgress }) => {

      let progress = 0;
      const interval = setInterval(() => {

        progress += 10;

        onProgress({ percent: progress });
        if (progress === 100) {

          onSuccess('ok');
          clearInterval(interval);
          setImageFile(file);
          progress = 0;

        }

      }, 150);

    }, [dispatch, dataForm, setDataForm],
  );

  const changeFile = (info) => {

    if (info.file.status === 'done') {

      message.success(`${info.file.name} file uploaded successfully`);

    } else if (info.file.status === 'error') {

      message.error(`${info.file.name} file upload failed.`);

    }

  };

  // eslint-disable-next-line
  const clearRol = (value) => {

    setTypeVisitor('');

    setDataForm({
      ...dataForm,
      role: value,
      business_id_visitor: '',
      business_id: [],
      clients_id: [],
      devices_id: [],
    });

    // Actualiza los valores de los campos del formulario
    form.setFieldsValue({
      ...dataForm,
      role: value,
      business_id_visitor: '',
      business_id: [],
      clients_id: [],
      devices_id: [],
    });

};

  // eslint-disable-next-line
  const restorePassword = () => { 
    console.log('info restorePassword');

};

  // Lo nuevo
  const readBusinessType = useCallback(async () => {

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

        const newBusiness = await Promise.all(business.map(async (obj) => {

          const item = {
            value: obj.id,
            label: obj.name,
            devices: obj.total_general,
            clients: obj.total_general_clients,
            type: obj.type,
          };

          return item;

}));

        setBusinessData(newBusiness);

      }).catch((resError) => {

        if (signal.aborted) return;
        const { fem } = resError;
        console.log('fem ', fem);

});

  });

  const onDataVisitor = useCallback(async (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds.length > 0) {

            businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      if (dataForm.role === 'Visitor') {

        setDataForm({
          ...dataForm,
          business_id_visitor: businessTypeIds,
          clients_id: [],
          devices_id: [],
        });

        // Actualiza los valores de los campos del formulario
        form.setFieldsValue({
          ...dataForm,
          business_id_visitor: businessTypeIds,
          clients_id: [],
          devices_id: [],
        });

        // eslint-disable-next-line
        const typeVisitor = businessData.find((obj) => obj.value === businessTypeIds)?.type;

        // eslint-disable-next-line
        if (typeVisitor) { 
          // eslint-disable-next-line
          setTypeVisitor(typeVisitor);

}

        // eslint-disable-next-line
        readDevices(businessTypeIdsQuery);

        // eslint-disable-next-line
        readClients(businessTypeIdsQuery);

      }

  });

  const readDevices = (businessTypes) => {

    devicesApi.getAllDeviceByBusiness2(signal, skip, limit, businessTypes)
      .then(async (devices) => {

        const newDevices = await Promise.all(devices.map(async (obj) => {

          const item = {
            value: obj.id,
            label: obj.name,
          };
          return item;

}));

        setDevicesData(newDevices);

      }).catch((resError) => {

        if (signal.aborted) return;
        const { fem } = resError;
        console.log('fem ', fem);

});

};

  const readClients = (businessTypes) => {

    devicesApi.getAllClientsByBusiness(signal, skip, limit, businessTypes)
      .then(async (clients) => {

        const newClients = await Promise.all(clients.map(async (obj) => {

          const item = {
            value: obj.id,
            label: obj.celsia_id,
          };

          return item;

        }));

        setClientsData(newClients);

      }).catch((resError) => {

        if (signal.aborted) return;
        const { fem } = resError;
        console.log('fem ', fem);

});

  };

  useEffect(() => {

    readBusinessType();

  }, []);

  useEffect(() => {

    if (idToEdit && dataInit?.role === 'Visitor' && businessData.length > 0) {

      const businessTypeIds = dataInit?.business_id_visitor;

      let businessTypeIdsQuery = '';

      if (businessTypeIds.length > 0) {

            businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      if (dataForm.role === 'Visitor') {

        // eslint-disable-next-line
        const typeVisitor = businessData.find((obj) => obj.value === businessTypeIds)?.type;

        // eslint-disable-next-line
        if (typeVisitor) { 
          // eslint-disable-next-line
          setTypeVisitor(typeVisitor);

}

        // eslint-disable-next-line
        readDevices(businessTypeIdsQuery);

        // eslint-disable-next-line
        readClients(businessTypeIdsQuery);

      }

}

  }, [businessData]);

  /* useEffect(() => {

    if (dataForm.role === 'Visitor') {

      setDataForm({
        ...dataForm,
        devices_id: [],
      });

      // Actualiza los valores de los campos del formulario
      form.setFieldsValue({
        ...dataForm,
        devices_id: [],
      });
    }

  }, [devicesData]);

  useEffect(() => {

    if (dataForm.role === 'Visitor') {

      setDataForm({
        ...dataForm,
        clients_id: [],
      });

      // Actualiza los valores de los campos del formulario
      form.setFieldsValue({
        ...dataForm,
        clients_id: [],
      });
    }

  }, [clientsData]); */

  useEffect(() => { // mount component

    if (!idToEdit && location.pathname === '/usuarios/editar-usuario') {

          // If trying to edit without idToEdit, redirect to usuarios
          history.push('/usuarios');

    } else if (!idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

          // If trying to create without idToEdit and not Superadmin or Admin, redirect to usuarios
          history.push('/usuarios');

    }
        return function cleanUp() { // clean state in redux

          dispatch(usersAction.setIdUserEdit({ id: null, isAdmin: null }));
          dispatch(usersAction.setCreateEditUser(defaultData));

    };

  // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    fileRequest,
    changeFile,
    dataForm,
    idToEdit,
    cancelCreateEditUser,
    businessData,
    devicesData,
    clientsData,
    currentUserRol,
    onDataVisitor,
    clearRol,
    isModalVisible,
    setIsModalVisible,
    modalData,
    typeVisitor,
    form,
    loadingForm,
  };

}

export default useUsersEditCreate;
